import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgMastercardLogoBlackAndWhite = props => _jsxs("svg", _objectSpread(_objectSpread({
  width: 39,
  height: 25,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.477 19.329v.381h-.072v-.381h-.155v-.079h.391v.079h-.164Zm.76-.079v.46h-.083v-.348l-.128.299h-.089l-.128-.3v.35h-.086v-.461h.119l.138.329.138-.329h.118Z",
    fill: "#F79E1B"
  }), _jsx("path", {
    d: "M14 2.57h11v18.86H14V2.57Z",
    fill: "#858585"
  }), _jsx("path", {
    d: "M14.831 12.003a11.98 11.98 0 0 1 4.584-9.433 12 12 0 1 0 0 18.87 11.98 11.98 0 0 1-4.584-9.437Z",
    fill: "#494949"
  }), _jsx("path", {
    d: "M32.074 22.794a11.999 11.999 0 0 1-12.659-1.36 11.998 11.998 0 0 0 0-18.868 11.999 11.999 0 1 1 12.66 20.228Z",
    fill: "#AAA"
  })]
}));
export default SvgMastercardLogoBlackAndWhite;